import { determineSearchType, SearchType } from './helpers'
import styled from '@emotion/styled'
import { PAGE_BREAKPOINTS } from 'parameters/index'
import { SearchWithExtras } from 'generated/api'
import { skComponent } from 'components/patterns/Skeleton'
import { LinkButton } from 'ui/inputs/Button'
import { btn } from './CtaButtons.css'
import { Button } from 'ui/inputs/Button/LegacyButtonCompatibility'

interface SearchCTAButtonProps {
	search?: SearchWithExtras
}

export const CallToActionButton = ({ search }: SearchCTAButtonProps): JSX.Element => {
	const searchType = determineSearchType(search)

	if (search === undefined) {
		return skComponent(Button, { width: '100%' })
	}

	const fallbackHref = '/explore/loans'
	switch (searchType) {
		case SearchType.legacy:
			return (
				<RatesButton alwaysFullWidth={true}>
					<LinkButton href={search?.summary?.legacyView || fallbackHref} className={btn}>
						See Your Offers
					</LinkButton>
				</RatesButton>
			)

		case SearchType.inProgress:
			return (
				<RatesButton alwaysFullWidth={true}>
					<LinkButton variant="secondary" href="/explore/loans" className={btn}>
						Finish Now
					</LinkButton>
				</RatesButton>
			)

		case SearchType.hasActiveOffers:
			const offerCountNotNull = search?.summary?.offerCount || 0
			const offerText = offerCountNotNull > 1 ? `${offerCountNotNull}` : ''
			return (
				<RatesButton alwaysFullWidth={true}>
					<LinkButton href="/explore/loans" className={btn}>{`See your ${offerText} offers`}</LinkButton>
				</RatesButton>
			)
	}
	return <span />
}

const RatesButton = styled.div<{ alwaysFullWidth?: boolean }>`
	width: ${(props): string => (props.alwaysFullWidth ? '100%' : '250px')};
	margin-top: 8px;

	button {
		width: 100%;
	}

	@media only screen and (${PAGE_BREAKPOINTS.TABLET_PORTRAIT}) {
		width: 100%;
	}
`
